import React , {useState , useEffect} from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import slide3 from "../assets/star_of_the_seas_BANNER.png";
import silvervideo from "../assets/silversea.mp4";
import { faStar} from '@fortawesome/free-solid-svg-icons';
import '../silversea.css';
import Deal from "./Deal";
import Dealdata from "./Dealdata";
import SilverSuite from '../assets/silver_luxury.jpg'
import Oceanview from '../assets/silver-ocean.jpg';
import Personalize from '../assets/personalize silver.jpg';
import Finedine from '../assets/fine dining silver.jpg';
// import Mastersuite from '../assets/silver master suite.jpg';
import OSbedroom from "../assets/SSC_OwnerSuite_bed.png";
import OSliving from "../assets/SSC_OwnerSuite_Livingroom.png";
import OSdining from "../assets/SSC_OwnerSuite_dining.png";
import OSbathroom from "../assets/SSC_OwnerSuite_bathroom.png";

import SilverSeaForm from "./SilverSeaLeadForm";
import { ReactComponent as Next } from '../assets/next.svg';
import { ReactComponent as Pre } from '../assets/pre.svg';
import '../royal.css'
import ScrolltoTop from "./ScrolltoTop";




const Silver = () => {

   // signature cruise

   const [ssindex, sssetIndex] = useState(0); // initial slide index
  
   const [sscardsPerView, sssetCardsPerView] = useState(2);
 
   // Array of only the selected deals
   const ssselectedDeals = [Dealdata[13], Dealdata[9], Dealdata[14] , Dealdata[78], Dealdata[79], Dealdata[80]];
 
   useEffect(() => {
       const ssupdateCardsPerView = () => {
         sssetCardsPerView(window.innerWidth < 768 ? 1 : 2);
       };
       ssupdateCardsPerView();
       window.addEventListener('resize', ssupdateCardsPerView);
       return () => window.removeEventListener('resize', ssupdateCardsPerView);
     }, []);
   
 
   const ssmaxIndex = ssselectedDeals.length - sscardsPerView;
 
   const sshandlePrev = () => {
     sssetIndex((prev) => (prev <= 0 ? ssmaxIndex : prev - 1));
   };
   
   const sshandleNext = () => {
     sssetIndex((prev) => (prev >= ssmaxIndex ? 0 : prev + 1));
   };
 
   const ssvisibleDeals = ssselectedDeals.slice(ssindex, ssindex + sscardsPerView);
 

    //silver fleet

  const [sfindex, sfsetIndex] = useState(0); // initial slide index

  const [sfcardsPerView, sfsetCardsPerView] = useState(2);
  

  // Array of only the selected deals
  const sfselectedDeals = [Dealdata[66], Dealdata[67], Dealdata[68] , Dealdata[69], Dealdata[70], Dealdata[71], Dealdata[72], Dealdata[73], Dealdata[74], Dealdata[75], Dealdata[76], Dealdata[77]];

useEffect(() => {
    const sfupdateCardsPerView = () => {
      sfsetCardsPerView(window.innerWidth < 768 ? 1 : 2);
    };
    sfupdateCardsPerView();
    window.addEventListener('resize', sfupdateCardsPerView);
    return () => window.removeEventListener('resize', sfupdateCardsPerView);
  }, []);

  const sfmaxIndex = sfselectedDeals.length - sfcardsPerView;

  const sfhandlePrev = () => {
    sfsetIndex((prev) => (prev <= 0 ? sfmaxIndex : prev - 1));
  };
  
  const sfhandleNext = () => {
    sfsetIndex((prev) => (prev >= sfmaxIndex ? 0 : prev + 1));
  };

  const sfvisibleDeals = sfselectedDeals.slice(sfindex, sfindex + sfcardsPerView);


    
    return(
        <>
        <Navbar/>
        <div className="header">
            <div className="offer-alert">
                <div>
                    <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                    <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                    <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                    <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                    <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                </div>
                <p>4.8 Overall Rating and 5,00,000+ happy customers</p>
            </div>


            <div className= "ajslider silversea-header-main">
            {/* <div id="carouselExampleIndicators" class="carousel slide ajslider"> */}

           <div className="royal-image">
            {/* <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=8&Destinations=16,39,40,41,18&sortColumn=cruiselinePriority&sortOrder=asc" target="_self" rel="noopener noreferrer"> <img src={slide3} alt="Royal Caribbean" style={{cursor:'pointer'}}/></a> */}
            <video style={{ width: '100%', height: '80vh',objectFit: 'fill' }} autoPlay loop muted >
        <source src={silvervideo} type="video/mp4" />
      </video>

         </div>
  {/* <div class="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button>

  </div>
  <div class="carousel-inner">
    <div class="carousel-item active">
      <img src={slide1} class="d-block w-100" alt="..."/>
    </div>
    <div class="carousel-item">
      <img src={slide2} class="d-block w-100" alt="..."/>
    </div>
    <div class="carousel-item">
      <img src={slide3} class="d-block w-100" alt="..."/>
    </div>
    <div class="carousel-item">
      <img src={slide4} class="d-block w-100" alt="..."/>
    </div>
  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button> */}
  

  <div>
      <SilverSeaForm />
      </div>

</div>

</div>

<div className="silversea-container ">
<p>
Silversea intimate luxury ships cater to discerning travelers. Boasting only spacious ocean-view suites with butler service and private verandas, guests savor breathtaking scenery in opulence. Navigating to over 800 destinations on all continents, embrace refined exploration and sumptuous comfort with Silversea.
</p>
<p>TIRUN exclusively represents Silversea as part of its portfolio of experiences.</p>
</div>


<div className="royal-adventure silver-content" style={{marginTop:'15vh'}}> 
            
            <div className="content ">
            <h2>Destinations</h2>
            <p><span style={{fontWeight:'600',fontSize:'1.25rem'}}>Explore the World in Unmatched Elegance with Silversea</span><br></br><br></br>
Sail all seven continents with ease on ultra-luxury, all-inclusive cruises.
Immerse yourself in iconic ports and remote frontiers alike.
From Seville’s charm to Antarctica’s raw beauty—discover it all.
Choose classic voyages or daring expeditions tailored for the curious soul.
Longer stays, deeper connections, and unmatched comfort await.
With Silversea, every journey is a refined voyage of discovery.

</p>
            </div>
        {/* <div className="trip silver-content-card">
           <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=8&Destinations=16,39,40,41,18&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer" >  <Deal img={Dealdata[13].img } Dealname={Dealdata[13].Dealname}   /></a>
           <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=2&Destinations=1&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer"> <Deal img={Dealdata[14].img } Dealname={Dealdata[14].Dealname}  /></a>
           <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=2&Destinations=1&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer"> <Deal img={Dealdata[9].img } Dealname={Dealdata[9].Dealname}  /></a>
        </div> */}

        <div className="carousel-wrapper silver-signature" >
        <button onClick={sshandlePrev} style={{backgroundColor:'transparent',border:'none'}} >
          <Pre style={{width:'30px', height:'30px',opacity:'0.3'}}/>
        </button>

        <div className="trip silver-content-card" style={{ display: 'flex', gap: '20px' , transition: 'transform 0.5s ease-in-out'}}>
           {ssvisibleDeals.map((deal, i) => (
          <a
            key={i}
            href={deal.link}
            target="_self"
            rel="noopener noreferrer"
            style={{ flex: '1', textDecoration: 'none' }}
          >
            <Deal img={deal.img} Dealname={deal.Dealname} />
          </a>
        ))}
        </div>
        <button
          onClick={sshandleNext} style={{backgroundColor:'transparent',border:'none'}} 
        >
         <Next style={{width:'30px', height:'30px', opacity:'0.3'}}/>
        </button>
        
        </div>
        </div>

      


        <div className="royal-adventure  silver-adventure " style={{marginTop:'20vh',marginBottom:'15vh', alignItems:'flex-start',justifyContent:'center', display:'flex'}}> 
            
            <div className="content silver-style">
            <h2 style={{fontSize:'1.4rem', lineHeight:'1.5'}}>Silversea strives to ensure your journey is unforgettable,
            transporting you to the planet's most stunning destinations in the luxury you deserve.</h2>
            <p>Designed for those who relish in exploration and lavishness, Silversea intimate  luxury ships boast spacious ocean-view suites with butler service. Most feature private verandas, allowing guests to savor champagne while admiring the breathtaking vistas. From icy panoramas to tropical landscapes, the choice is yours. Sailing from pole to pole, Silversea ships reach over 800 destinations across all seven continents, leaving virtually no coastline unexplored.</p>
            </div>
        {/* <div className="suite silver-suite"> */}
          <img src={SilverSuite} alt="Royal Caribbean at Sea" className="silver-suite-img"/>
        {/* </div> */}

        </div>


{/* silverv experionce */}
        <div className="row row-cols-1 row-cols-md-3 g-5 silver-experience">
  <div className="col silver-card">
    <div class="card h-100">
      <img src={Oceanview} class="card-img-top" alt="..."/>
      <div class="card-body">
        <h5 class="card-title">Oceanview Suites</h5>
        <p class="card-text">No matter the ship or suite, all guests are treated to the personalized services of a devoted butler, ensuring a luxurious journey aboard the finest cruise line for upscale travel. For
an exceptionally tailored experience, customize your suite
with a wealth of optional amenities: from premium toiletries and personalized stationery to a bar stocked with your preferred wines and spirits, Silversea provides only the highest-quality comforts in luxury cruise accommodations. Delight in in-suite dining served by your butler and a choice of pillows. Silversea suites are genuinely your home away from home on the open
seas.</p>
      </div>
      {/* <div class="card-footer">
        <small class="text-body-secondary">Last updated 3 mins ago</small>
      </div> */}
    </div>
  </div>
  <div className="col silver-card">
    <div class="card h-100">
      <img src={Personalize} class="card-img-top" alt="..."/>
      <div class="card-body">
        <h5 class="card-title">Personalized Service</h5>
        <p class="card-text">At Silversea, every suite comes with a dedicated butler—trained to deliver intuitive, white-glove service from the moment you step onboard. From unpacking your bags and curating your minibar to arranging private in-suite dinners or cocktail gatherings, your every need is anticipated and fulfilled. Whether it’s a drawn bath, restaurant reservations, or keeping your suite immaculate, our butlers are there when you need them—and gracefully disappear when you don’t. It’s seamless, thoughtful, and always included. With Silversea, luxury isn't requested—it's delivered, naturally. Experience service that turns a great cruise into an unforgettable one.</p>
      </div>
      {/* <div class="card-footer">
        <small class="text-body-secondary">Last updated 3 mins ago</small>
      </div> */}
    </div>
  </div>
  <div className="col silver-card">
    <div class="card h-100">
      <img src={Finedine} class="card-img-top" alt="..."/>
      <div class="card-body">
        <h5 class="card-title">Fine Dining</h5>
        <p class="card-text">Recognizing the significance of cuisine in our culture, Silversea places a high emphasis on dining. They uphold gastronomic excellence as a standard, offering recipes that honor their heritage while reimagining tradition. Diverse and fresh selections showcase the influence of each destination, regardless of the dining venue. Each luxury ship also boasts a variety of dining options.

From elegant French fare and bold Asian flavors to comforting Italian dishes and global favorites, the chefs craft every meal with creativity and flair—turning every bite into a memorable part of your journey.</p>
      </div>
      {/* <div class="card-footer">
        <small class="text-body-secondary">Last updated 3 mins ago</small>
      </div> */}
    </div>
  </div>
</div>

{/* silver experince end */}

        <div className="royal-adventure silver-adventure" style={{marginTop:'20vh'}}> 
            
            <div className="content">
            <h2>Silversea Suite Experiences</h2>
            <p>Experience unparalleled luxury and comfort with Silversea offering elegant suites, exceptional amenities, and personalized services. Revel in the exclusivity of butler service, tailored in-suite details, spacious accommodations, 24- hour in-suite dining, and state-of-the-art entertainment technology. Silversea commitment to creating a bespoke and
            memorable voyage ensures a truly unforgettable journey through breathtaking destinations around the globe.</p>
            </div>
        {/* <div className="suite">
          <img src={Mastersuite} alt="Royal Caribbean at Sea" />
        </div> */}
        
        {/* <div class= "Royal-suite-container"> */}
            <div id="carouselExampleIndicators" class="carousel slide Celebrity-suite-carousel silversea-carousel">


        {/* <div class="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button>

  </div> */}
  <div class="carousel-inner">
    <div class="carousel-item active">
      <img src={OSbedroom} class="d-block w-100" alt="..."  />
    </div>
    <div class="carousel-item">
      <img src={OSliving} class="d-block w-100" alt="..."  />
    </div>
    <div class="carousel-item">
      <img src={OSdining} class="d-block w-100" alt="..."  />
    </div>
    <div class="carousel-item">
      <img src={OSbathroom} class="d-block w-100" alt="..." />
    </div>
  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
  </div>
  </div>

        {/* </div> */}


        <div className="royal-adventure silver-content silver-fleet" style={{marginBottom:'40vh',marginTop:'20vh'}}> 
            
            <div className="content">
            <h2>Signature Fleet</h2>
            <p>Experience the pinnacle of luxury and comfort aboard Silversea world-class fleet of intimate cruise ships.</p>
            </div>
        {/* <div className="trip silver-content-card">
           <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=8&Destinations=16,39,40,41,18&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer" >  <Deal img={Dealdata[15].img } Dealname={Dealdata[15].Dealname}   /></a>
           <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=2&Destinations=1&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer"> <Deal img={Dealdata[16].img } Dealname={Dealdata[16].Dealname}  /></a>
           <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=2&Destinations=1&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer"> <Deal img={Dealdata[66].img } Dealname={Dealdata[66].Dealname}  /></a>
        </div> */}

        <div className="carousel-wrapper silver-signature" >
        <button onClick={sfhandlePrev} style={{backgroundColor:'transparent',border:'none'}} >
          <Pre style={{width:'30px', height:'30px',opacity:'0.3'}}/>
        </button>

        <div className="trip silver-content-card" style={{ display: 'flex', gap: '20px' , transition: 'transform 0.5s ease-in-out'}}>
           {sfvisibleDeals.map((deal, i) => (
          <a
            key={i}
            href={deal.link}
            target="_self"
            rel="noopener noreferrer"
            style={{ flex: '1', textDecoration: 'none' }}
          >
            <Deal img={deal.img} Dealname={deal.Dealname} />
          </a>
        ))}
        </div>
        <button
          onClick={sfhandleNext} style={{backgroundColor:'transparent',border:'none'}} 
        >
         <Next style={{width:'30px', height:'30px', opacity:'0.3'}}/>
        </button>
        
        </div>

        </div>

       <ScrolltoTop/>

       <Footer/> 

        </>
    );
}

export default Silver;